import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-event-details',
  imports: [CommonModule, TranslateModule ],
  templateUrl: './event-details.component.html',
  styleUrl: './event-details.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class EventDetailsComponent {
  @Input() selectedEvent: any;
  @Input() selectedEventAction: any;
}
